import { MyLink } from '@ui-kit/Link';
import { PropsLinkAction } from './PropsLinkAction';
import classNames from 'classnames';
import IconAction from './actions.svg';

import styles from './LinkAction.module.scss';

export const LinkAction = ({ className, color, ...other }: PropsLinkAction): JSX.Element => {
  return (
    <MyLink href={'/actions/'} className={classNames(styles.Link, color === 'orange' && styles.Orange, className)} {...other}>
      <IconAction width={24} height={24} />
      Акции
    </MyLink>
  );
};
